var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcScheduleNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231815",
    fillRule: "evenodd",
    d: "M7.5 2A1.5 1.5 0 006 3.5V4H4a2 2 0 00-2 2v14a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2h-2v-.5a1.5 1.5 0 00-3 0V4H9v-.5A1.5 1.5 0 007.5 2zm9 5a1.5 1.5 0 01-1.415-1h-6.17a1.5 1.5 0 01-2.83 0H4v2h16V6h-2.085A1.5 1.5 0 0116.5 7zm3.5 3H4v10h16V10zm-9 2a1 1 0 012 0v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2v-2z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3E %3Cpath fill='%23231815' fill-rule='evenodd' d='M7.5 2C6.672 2 6 2.672 6 3.5V4H4c-1.105 0-2 .895-2 2v14c0 1.105.895 2 2 2h16c1.105 0 2-.895 2-2V6c0-1.105-.895-2-2-2h-2v-.5c0-.828-.672-1.5-1.5-1.5S15 2.672 15 3.5V4H9v-.5C9 2.672 8.328 2 7.5 2zm9 5c-.653 0-1.209-.417-1.415-1h-6.17c-.206.583-.762 1-1.415 1s-1.209-.417-1.415-1H4v2h16V6h-2.085c-.206.583-.762 1-1.415 1zm3.5 3H4v10h16V10zm-9 2c0-.552.448-1 1-1s1 .448 1 1v2h2c.552 0 1 .448 1 1s-.448 1-1 1h-2v2c0 .552-.448 1-1 1s-1-.448-1-1v-2H9c-.552 0-1-.448-1-1s.448-1 1-1h2v-2z' clip-rule='evenodd'/%3E %3C/svg%3E";
export { SvgIcScheduleNormal as ReactComponent };